// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"da93cd1d","487":"e0b27b85","651":"1ceccfb5"}[chunkId] + ".chunk.js";
};